export const INTENT_STORAGE_KEY = "passport.launch.intent";
export const PLAYER_STORAGE_KEY = "passport.launch.playerId";
export const CLASS_ID_STORAGE_KEY = "passport.launch.classId";
export const ACTIVITY_ID_STORAGE_KEY = "passport.launch.activityId";
export const LAUNCH_ID_STORAGE_KEY = "passport.launch.launchId";

export const INTENT_PICK = "PICK";
export const INTENT_PERFORM = "PERFORM";

export type LaunchIntent = typeof INTENT_PICK | typeof INTENT_PERFORM;
